import { Injectable } from '@angular/core';
import { element } from 'protractor';
import { Role } from 'src/userRoles/userRoles';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  addmode: boolean;
  editmode: boolean;
  userRole: Role;



  getEditmode(): boolean {
    return this.editmode;
  }
  setEditmode(data: boolean) {
    this.editmode = data;
  }

  getAddmode(): boolean {
    return this.addmode;
  }
  setAddmode(data: boolean) {
    this.addmode = data;
  }


  getUserRole(): Role {
    return this.userRole;
  }

  setUserRole(role: Role) {
    this.userRole = role;
  }


  constructor() {
    this.setAddmode(false);
    this.setEditmode(false);
  }
}
